import { IFRAME_ID } from '../../../../shared/js/constants/ids';
import { WIDGET_STATE } from '../../constants/app';

const { OPENED } = WIDGET_STATE;
const parentDocument = parent.document;

export function updateHostMinSize(widgetState, proactiveMessages) {
    // Wait until the proactive message element has been rendered
    window.requestAnimationFrame(() => {
        const container = document.getElementById('bb-proactive-messages-container');
        const iframe = parentDocument.getElementById(IFRAME_ID);

        const pmCount = proactiveMessages.active.filter((pm) => pm.closed === false).length;

        if (widgetState === OPENED || pmCount === 0 || container === null) {
            iframe.style.minWidth = '';
            iframe.style.minHeight = '';
        } else {
            iframe.style.minWidth = container.offsetWidth + 'px';
            iframe.style.minHeight = container.offsetHeight + 'px';
        }
    });
}
